import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import ResultsSection from '../redesign/components/ResultsSection'
import OddsCalculator from '../redesign/components/OddsCalculator'
import InfoBar from '../redesign/components/InfoBar'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'

const ArbitrazniKalkulator = () => {
  const [totalStake, setTotalStake] = useState('')
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      one: ['', ''],
      two: ['', ''],
      three: ['', ''],
      four: ['', ''],
      five: ['', ''],
      six: ['', ''],
      seven: ['', ''],
      eight: ['', ''],
      nine: ['', ''],
    },

    total: totalStake,
    results: {
      one: ['-', '', '', '', '', '', ''],
      two: ['-', '', '', '', '', '', ''],
      three: ['-', '', '', '', '', '', ''],
      four: ['-', '', '', '', '', '', ''],
      five: ['-', '', '', '', '', '', ''],
      six: ['-', '', '', '', '', '', ''],
      seven: ['-', '', '', '', '', '', ''],
      eight: ['-', '', '', '', '', '', ''],
      nine: ['-', '', '', '', '', '', ''],
      total: totalStake,
    },
  })

  const calculateBets = () => {
    const updatedData = JSON.parse(JSON.stringify(data))
    const keys = Object.keys(updatedData.values)
    const kvotaInputsArr = keys.map(
      (key) => parseFloat(updatedData.values[key][1]) || 0
    )

    const procenatKvoteArr = kvotaInputsArr.map((kvota) => {
      const procenat = (1 / kvota) * 100
      return !isFinite(procenat) ? 0 : Number(procenat.toFixed(2))
    })

    const zbirProcenata = procenatKvoteArr.reduce((acc, val) => acc + val, 0)
    const profitKladionice =
      totalStake === 0 ? 0 : Number((zbirProcenata - 100).toFixed(2))

    const validCount = procenatKvoteArr.filter((v) => v !== 0).length
    const procenatPoTipuArr = procenatKvoteArr.map(() => {
      const proc = profitKladionice / validCount
      return !isFinite(proc) ? 0 : Number(proc.toFixed(2))
    })

    const dobitakArr = kvotaInputsArr.map((_, idx) => {
      const ajSum = procenatKvoteArr.reduce(
        (acc, perc) => acc + (totalStake * perc) / 100,
        0
      )
      const profit = totalStake - ajSum
      const final = totalStake - parseFloat(Math.abs(profit).toFixed(2))
      return Number(final.toFixed(2))
    })

    const ulogPoTipuArr = dobitakArr.map((value, index) => {
      const stake = value / kvotaInputsArr[index]
      return !isFinite(stake) ? 0 : Number(stake.toFixed(2))
    })

    const plusArr = dobitakArr.map((value) => {
      const net = totalStake - value
      return Number(net.toFixed(2))
    })

    keys.forEach((key, index) => {
      const odds = kvotaInputsArr[index]

      if (!odds || odds === 0) {
        // Fill all fields with '-' if odds are empty
        updatedData.results[key] = ['-', '-', '-', '-', '-', '-', '-']
      } else {
        updatedData.results[key] = [
          updatedData.values[key][0] || '-',
          odds.toFixed(2),
          procenatKvoteArr[index]?.toFixed(2),
          procenatPoTipuArr[index]?.toFixed(2),
          ulogPoTipuArr[index]?.toFixed(2),
          dobitakArr[index]?.toFixed(2),
          plusArr[index]?.toFixed(2),
        ]
      }
    })

    const totalNetProfit = plusArr.reduce((acc, val) => acc + val, 0)
    updatedData.results.total = totalNetProfit.toFixed(2)

    setData(updatedData)
  }

  const [showInputArea, setShowInputArea] = useState(true)

  const clearFields = () => {
    setData({
      values: {
        one: ['', ''],
        two: ['', ''],
        three: ['', ''],
        four: ['', ''],
        five: ['', ''],
        six: ['', ''],
        seven: ['', ''],
        eight: ['', ''],
        nine: ['', ''],
      },
      results: {
        one: ['-', '', '', '', '', '', ''],
        two: ['-', '', '', '', '', '', ''],
        three: ['-', '', '', '', '', '', ''],
        four: ['-', '', '', '', '', '', ''],
        five: ['-', '', '', '', '', '', ''],
        six: ['-', '', '', '', '', '', ''],
        seven: ['-', '', '', '', '', '', ''],
        eight: ['-', '', '', '', '', '', ''],
        nine: ['-', '', '', '', '', '', ''],
        total: '',
      },
    })
    setTotalStake('')
    setShowInputArea(true)
  }

  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    console.log('data', data)
    console.log('results', data?.results)
  }, [data])
  const firstTwoFieldsFilled = () => {
    return (
      data.values.one[0] !== '' &&
      data.values.one[1] !== 0 &&
      data.values.two[0] !== '' &&
      data.values.two[1] !== 0
    )
  }

  const allFieldsFilled = () => {
    return Object.values(data.values).every(
      (field) => field[0] !== '' && field[1] !== 0
    )
  }

  useEffect(() => {
    if (firstTwoFieldsFilled() || allFieldsFilled()) {
      setDisabled(false)
    }
  }, [data.values])

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={'Arbitrazni betko kalkulator'}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>

        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>Upis ukupnog uloga</div>
            <div className={classesK.oddsContainer}>
              <span>Upiši ukupan ulog</span>
              <input
                type='number'
                min='0'
                value={totalStake}
                onChange={(e) => {
                  const value = parseFloat(e.target.value)
                  setTotalStake(value)
                  setData((prevData) => ({
                    ...prevData,
                    total: value,
                  }))
                }}
              />
            </div>
            <div className={classesK.sectionTitle}>Upis kvota</div>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((index) => {
              const labelOneName = `Upiši igru broj ${index + 1}`
              const labelTwoName = `Upiši kvotu ${index + 1}`

              return (
                <OddsCalculator
                  key={index}
                  data={data.values}
                  setData={setData}
                  field={Object.keys(data.values)[index]}
                  labelPrefix={[labelOneName, labelTwoName]}
                  type={['text', 'number']}
                  min={['', '0.1']}
                  step={['', '0.1']}
                  calculation={calculateBets}
                  setError={setError}
                  rows={2}
                />
              )
            })}
          </>
        )}

        <div className={classesK.sectionResults}>
          {/* <ResultsSection
          title={'Profit kladionice'}
            subtitle={'Prikaz + /-'}
            results={[]}/> */}

          {!showInputArea &&
            Object.keys(data?.results).map((key, index) => {
              if (key === 'total') return null
              const labelOneName = `Igra za par ${index + 1}`
              const labelTwoName = `Kvota za Par ${index + 1}`
              return (
                <ResultsSection
                  key={key}
                  subtitle={'Par ' + (index + 1)}
                  results={data?.results[key].map((result, idx) => {
                    if (idx === 2 || idx === 3) {
                      if (isFinite(result)) return `${result}%`
                      return `${result}`
                    }
                    return result
                  })}
                  rows={4}
                  names={[
                    labelOneName,
                    labelTwoName,
                    'Procenat kvote (%)',
                    'Procenat po tipu (%)',
                    'Ulog na ovaj tip',
                    'Dobitak/Gubitak',
                    'Čist PLUS/MINUS',
                  ]}
                  allowNegative={true}
                />
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default ArbitrazniKalkulator
